module.exports = __webpack_public_path__ + "img/Avatar-38.9483830a.svg";